'use client';

import { Box, Flex, Text, Heading } from '@skin-seoul/design-system';
import NextImage from 'next/image';
import { useCountdown } from '../hooks/useCountdown';
import { CountdownTimer } from './CountdownTimer';
import campaignBannerBg from '../assets/campaign-banner-bg.png';
type CampaignBannerProps = {
  endDate: string;
  title: string;
  subtitle: string;
};
export const CampaignBanner = ({
  endDate,
  title,
  subtitle
}: CampaignBannerProps) => {
  const countdown = useCountdown(endDate);
  if (countdown.isExpired) {
    return null;
  }
  return <Box width="100%" borderRadius="12px" paddingY={5} paddingX={{
    base: 4,
    desktop: 6
  }} position="relative" overflow="hidden" alignContent="center" gap={4} data-sentry-element="Box" data-sentry-component="CampaignBanner" data-sentry-source-file="CampaignBanner.tsx">
      <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={0} data-sentry-element="Box" data-sentry-source-file="CampaignBanner.tsx">
        <NextImage src={campaignBannerBg} alt="Year End Campaign Banner Background" fill style={{
        objectFit: 'cover'
      }} data-sentry-element="NextImage" data-sentry-source-file="CampaignBanner.tsx" />
      </Box>
      <Flex direction={{
      base: 'column',
      desktop: 'row'
    }} alignItems={{
      base: 'flex-start',
      desktop: 'center'
    }} justifyContent="space-between" gap={{
      base: 4,
      desktop: 6
    }} width="100%" position="relative" zIndex={2} data-sentry-element="Flex" data-sentry-source-file="CampaignBanner.tsx">
        <Flex direction="column" gap={1} position="relative" flex="1" data-sentry-element="Flex" data-sentry-source-file="CampaignBanner.tsx">
          <Heading textStyle="heading.h6" fontWeight="bold" color="warning.400" data-sentry-element="Heading" data-sentry-source-file="CampaignBanner.tsx">
            {title}
          </Heading>
          <Text textStyle={{
          base: 'paragraph.medium',
          desktop: 'paragraph.xsmall'
        }} fontWeight="regular" color="neutral.200" data-sentry-element="Text" data-sentry-source-file="CampaignBanner.tsx">
            {subtitle}
          </Text>
        </Flex>

        <Flex alignItems="center" justifyContent={{
        base: 'center',
        desktop: 'flex-end'
      }} width={{
        base: '100%',
        desktop: 'auto'
      }} data-sentry-element="Flex" data-sentry-source-file="CampaignBanner.tsx">
          <CountdownTimer time={countdown} data-sentry-element="CountdownTimer" data-sentry-source-file="CampaignBanner.tsx" />
        </Flex>
      </Flex>
    </Box>;
};